import React from 'react';
import { Link } from 'react-router-dom';
import Divider from '../../ui_kit/utilities/divider';

import './index.css';

export default function PatientPartnerColumnForGallery({ partner, actionContent, index, article = false }) {
  if (index < 10) {
    index = '0' + index;
  }

  const imageUrl = partner.profile?.photo || '';

  const titleCase = (string) => {
    var surgery = string.toLowerCase().split(' ');
    for (var i = 0; i < surgery.length; i++) {
      if (surgery[i][0]) {
        surgery[i] = surgery[i][0].toUpperCase() + surgery[i].slice(1);
      }
    }
    return surgery.join(' ');
  };

  return (
    <div key={index} className='pp-pre-wrapper gallery-pp-column h-100'>
      <div className={`pp-wrapper h-100 ${article ? 'pp-grow' : ''}`}>
        <div
          className='circle-image'
          style={{
            backgroundImage: `url('${imageUrl}')`,
          }}
        ></div>
        <div className='content' style={{ marginBottom: '175px' }}>
          <h5 className='name row justify-content-center marg-top-80'>{partner.name}</h5>
          <div className='pp-details'>
            {partner.focus_areas && partner.focus_areas.length > 0 && (
              <h4 className='light-blue-text'>
                {partner.focus_areas
                  .sort()
                  .map((str) => titleCase(str))
                  .join(', ')}
              </h4>
            )}
            <div className='row justify-content-center'>
              {partner.display_location && (
                <p
                  className='location'
                  style={
                    partner.focus_areas && partner.focus_areas.length > 2 ? { marginTop: '0px' } : { marginTop: '5px' }
                  }
                >
                  {partner.display_location}
                </p>
              )}
            </div>
            <Divider color={'#888888'} />
            <div className='bio marg-top-10'>
              {(partner.bio || '')
                .split(/\n+/)
                .map((p) => p.trim())
                .filter(Boolean)
                .map((p, i) => (
                  <p key={i} style={{ marginTop: i === 0 ? 0 : '12px' }}>
                    {p}
                  </p>
                ))}
            </div>
          </div>
        </div>
        <div className='action-content marg-top-30 ' style={{ position: 'absolute', bottom: '0px' }}>
          <Link to={`/member/profile/${partner.slug}/about-me`}>
            <button
              data-pendo-tag={`mentor gallery - read full bio - ${partner.name}`}
              style={{ width: '80%', marginRight: '0px' }}
              className='marg-bottom-10 tertiary_hov'
            >
              See full profile
            </button>
          </Link>
          {actionContent}
        </div>
      </div>
    </div>
  );
}
